jQuery(function($){
	$('.arrangement-modal-wrapper .arrangement-modal-background').on('click', function(){
		closeArrangementModal($(this));
	});

	$('.arrangement-modal-wrapper .arrangement-modal-close').on('click', function(){
		closeArrangementModal($(this));
	});

	function closeArrangementModal(el) {
		const modalWrapper = el.closest('.arrangement-modal-wrapper');
		modalWrapper.find('.arrangement-modal').removeClass('showing');
		modalWrapper.find('.arrangement-modal-background').removeClass('visible');
	}

	$('.arrangement-modal-wrapper input#preview_copy').on('change', function(){
		const isChecked = this.checked;
		const parentForm = $(this).closest('form');

		if(isChecked) {
			parentForm.addClass('preview-copy-fields').find('input[name="num_copies"]').each(function(){
				$(this).attr('required', false);
				if(this.hasAttribute('data-min')) {
					$(this).attr('min', '');
				}
			});
		} else {
			parentForm.removeClass('preview-copy-fields').find('input[name="num_copies"]').each(function(){
				$(this).attr('required', true);
				if(this.hasAttribute('data-min')) {
					$(this).attr('min', $(this).attr('data-min'));
				}
			});

		}

		setButtonDisableStatus(parentForm);
	});

	$('.arrangement-modal-wrapper .arrangement-modal-acknowledgements input[type="checkbox"]').on('change', function(){
		const parentForm = $(this).closest('form');
		setButtonDisableStatus(parentForm);
	});

	$('.arrangement-modal-wrapper .cs-consent-checkbox input[type="checkbox"]').on('change', function(){
		const parentForm = $(this).closest('form');
		setButtonDisableStatus(parentForm);
	});

	$('.arrangement-modal-wrapper input:required').on('change', function(){
		const parentForm = $(this).closest('form');
		setButtonDisableStatus(parentForm);
	});

	function setButtonDisableStatus(parentForm) {
		let buttonDisabled = false;
		if(parentForm.hasClass('preview-copy-fields')) {
			parentForm.find('.arrangement-modal-acknowledgements input[type="checkbox"]').each(function(){
				if(!this.checked) buttonDisabled = true;
			});
		}

		if(parentForm.find('.cs-consent-checkbox').length) {
			parentForm.find('.cs-consent-checkbox input[type="checkbox"]').each(function(){
				if(!this.checked) buttonDisabled = true;
			});
		}

		parentForm.find('input:required').each(function(){
			console.log($(this).val());
			console.log($(this));
			if(!$(this).val()) buttonDisabled = true;
		});
	
		parentForm.find('input[type="submit"]').attr('disabled', buttonDisabled);
	}
});